
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.131 17.0185C37.7887 17.0185 38.3215 16.4854 38.3215 15.828V9.60762C38.3215 9.15382 38.0637 8.7397 37.6566 8.53951L20.5457 0.122452C20.2142 -0.0408173 19.826 -0.0408173 19.4946 0.122452L2.38373 8.53951C1.97662 8.7397 1.71875 9.15382 1.71875 9.60762V15.828C1.71875 16.4854 2.25189 17.0185 2.90924 17.0185H4.12445V33.4394H2.90924C2.25189 33.4394 1.71875 33.9725 1.71875 34.6299V38.8096C1.71875 39.4672 2.25189 40.0001 2.90924 40.0001H37.131C37.7887 40.0001 38.3215 39.4672 38.3215 38.8096V34.6299C38.3215 33.9725 37.7887 33.4394 37.131 33.4394H35.9158V17.0185H37.131ZM4.09943 10.3486L20.0201 2.51717L35.9409 10.3486V14.6375H4.09943V10.3486ZM23.9212 33.4394V17.0185H28.114V33.4394H23.9212ZM16.1191 17.0185V33.4394H11.9263V17.0185H16.1191ZM18.4998 17.0185H21.5402V33.4394H18.4998V17.0185ZM6.50513 17.0185H9.54559V33.4394H6.50513V17.0185ZM35.9409 37.6194H4.09943V35.8204H35.9409V37.6194ZM33.5352 33.4394H30.4947V17.0185H33.5352V33.4394Z"}}),_c('path',{attrs:{"d":"M26.444 7.09375H13.5967C12.9393 7.09375 12.4065 7.62659 12.4065 8.28394V12.1713C12.4065 12.8286 12.9393 13.3618 13.5967 13.3618H26.444C27.1013 13.3618 27.6342 12.8286 27.6342 12.1713V8.28394C27.6342 7.62659 27.1013 7.09375 26.444 7.09375ZM25.2535 10.9811H14.7872V9.47443H25.2535V10.9811Z"}})])
          )
        }
      }
    